import type {SpacePublicInfo} from "@src/features/auth/auth-models";
import {selectSpacesPublicInfo} from "@src/features/auth/redux/auth-slice";
import {useAppSelector} from "@src/integrations/redux/redux-store";
import {useParams} from "react-router-dom";


export function useSelectedSpace(): SpacePublicInfo | null {
	// todo make a version that returns non null value for when inside require space membership layout and move it
	//  to auth/hooks
	const routeParams = useParams();
	
	const spacesPublicInfo = useAppSelector(selectSpacesPublicInfo);
	
	const selectedSpaceId = routeParams.spaceId;
	if (!selectedSpaceId) {
		return null;
	}
	
	const spacePublicInfo = spacesPublicInfo.find(it => it.spaceId === selectedSpaceId);
	return spacePublicInfo ?? null;
}
